/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const form = {
  formId: 'edit-client-form',
  formField: {
    name: {
      name: 'name',
      label: 'Name',
      type: 'text',
      errorMsg: 'Name is required.'
    },
    callbackUrl: {
      name: 'callbackUrl',
      label: 'Callback URL',
      type: 'text',
      errorMsg: 'Callback URL is required.'
    },
    whitelistedIps: {
      name: 'whitelistedIps',
      label: 'Whitelisted IPs',
      type: 'text',
      errorMsg: 'Whitelisted IPs are required.'
    }
  }
};

export default form;
